import { InfoCircle } from '@untitledui/icons';
import { Text } from '../general/Text';
import { Icon } from '../general/Icon';

interface NoticeRowProps {
  text: string;
}

export function NoticeRow({ text }: NoticeRowProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 0'
      }}
    >
      <Icon icon={InfoCircle} size={16} />
      <Text as='span' variant='body2-medium'>
        {text}
      </Text>
    </div>
  );
}
